'use strict';
type ArrayUtil = Core.ArrayUtil;

angular
    .module('carHire')
    .controller('CarHire', CarHire);

function CarHire($filter: any,
                 $q: ng.IQService,
                 $routeParams: any,
                 $scope: any,
                 arrayUtil: any,
                 basketService: any,
                 basketStore: any,
                 carHireDetailsService: any,
                 extraProductsService: any,
                 scrollService: any,
                 tripService: any
                ) {

    var ch = this;

    ch.noneCarHire = '-1';
    ch.currentCarHireLimit = ch.carHireLimit = 5;

    ch.DriverAgeConfig = {
        Min: 21,
        Max: 90
    };

    var deferred;
    var optionOperation;

    //Desktop
    ch.driverAgeList = arrayUtil.createRange(ch.DriverAgeConfig.Max, ch.DriverAgeConfig.Min);
    //DesktopEnd

    tripService.getTrip($routeParams.tripId).then(function (trip:any) {
        var basketId = trip.BasketId,
            tripId = trip.TripId,
            carHireSearchId = trip.CarHireRequest ? trip.CarHireRequest.AvailabilitySearchId : null,
            onewayonly = trip.FlightsRequest.OneWayOnly;

        ch.carHireDriverAge = trip.CarHireRequest ? trip.CarHireRequest.DriverAge : 30;

        $q.all([
            basketStore.carHire(basketId, $routeParams.productId),
            basketStore.rules(basketId, $routeParams.productId),
            basketStore.carHireOptions(basketId, $routeParams)
        ]).then(function (results:any) {

            var carHire = results[0] ? results[0].Details.CarHireId.CarHireCode : ch.noneCarHire;
            ch.basketRules = results[1];

            if ((TRPCONFIG.Domain.CarHireEnabled || TRPCONFIG.Domain.CarHireMobileEnabled) && !onewayonly) {

                $scope.$watch('ch.carHireDriverAge', _.debounce(function (val, oldVal) {
                    if (val == null) {
                        return;
                    }
                    ch.carHireBusyAvailability = true;
                    if (oldVal !== val) {
                        carHireSearchId = null;
                    }
                    deferred = $q.defer();

                    const processResults = (carHireQuotes, options) => {
                        ch.carHireQuotes = arrayUtil.sort(carHireQuotes, 'Price');
                        ch.carHireLimit = 5;
                        ch.carHireBusyAvailability = false;

                        if (!ch.carHire) {
                            ch.carHire = angular.copy(carHire);
                            ch.carHireSelectedOptions = _normaliseCarHireOptions(options) || [];
                        } else {
                            const quote = arrayUtil.first(ch.carHireQuotes, q => {
                                return q.CarHireId.CarHireCode === ch.carHire;
                            });
                            if (!quote) {
                                ch.carHire = angular.copy(ch.noneCarHire);
                            } else {
                                ch.appendDetails(quote);
                            }
                        }
                    };

                    if(carHireSearchId == null) {
                        basketService.getCarQuotes(basketId, tripId, ch.carHireDriverAge)
                            .then(quotes => processResults(quotes, results[2]));
                    } else {
                        basketService.getCarQuotesFromSession(carHireSearchId, 0)
                            .then(quotes => processResults(quotes, results[2]));
                    }

                }, 400));


                $scope.$watch('ch.carHire', _selectCar, true);

                $scope.$watch('ch.carHireSelectedOptions', optionsWatch, true);

            }

        }).then(angular.noop, basketService.restartHolidayWorkflow);

        ch.appendDetails = function (quote, $event) {

            if ($event) {
                $event.preventDefault();
            }

            _.each(ch.carHireQuotes, function(q:any) {
                q.viewDetails = false;
            });

            if (!quote.Details) {
                quote.busy = true;
                tripService.getTrip(tripId).then(function (t:any) {
                    carHireSearchId = t.CarHireRequest.AvailabilitySearchId;
                    carHireDetailsService
                        .getCarDetails({ AvailabilitySearchId: carHireSearchId, CarHireQuote: quote }, true)
                        .then(function (d) {
                            quote.viewDetails = true;
                            quote.Details = d;
                            quote.busy = false;
                            quote.showDetailsError = false;
                        }, function () {
                            quote.busy = false;
                            quote.showDetailsError = true;
                        });
                });
            } else {
                quote.viewDetails = true;
            }
        };

        ch.hideDetails = function(quote, $event) {
            if ($event) {
                $event.preventDefault();
            }
            quote.viewDetails = false;
        };

        ch.showMoreOrLess = function ($event) {
            if ($event) {
                $event.preventDefault();
            }
            var moreCarHireQuotes = ch.currentCarHireLimit !== ch.carHireQuotes.length;
            var currentCarHireLimit = moreCarHireQuotes ? ch.carHireQuotes.length : ch.carHireLimit;
            if (!moreCarHireQuotes) {
                scrollService.scrollTo('#car-hire-product-expander', {animate:true, offset:70}).then(function () {
                    ch.moreCarHireQuotes = false;
                    ch.currentCarHireLimit = currentCarHireLimit;
                });
            } else {
                ch.moreCarHireQuotes = true;
                ch.currentCarHireLimit = currentCarHireLimit;
            }
        };

        var selectingCar:any = $q.when();

        function _selectCar(val, oldVal) {
            if (val == null || val === oldVal) {
                return;
            }
            _updateSubtitle();

            if (val !== ch.noneCarHire) {
                var quote = arrayUtil.first(ch.carHireQuotes, function (q) {
                    return q.CarHireId.CarHireCode === val;
                });
                if (!!quote) {
                    quote.busy = !quote.Details;

                    if (!deferred) {
                        deferred = $q.defer();
                    }

                    var select = function() {
                        return tripService.getTrip(tripId).then(function(t:any) {
                            carHireSearchId = t.CarHireRequest.AvailabilitySearchId;
                            return basketService.selectCar(quote, carHireSearchId, basketId)
                            .then(function(d:any) {
                                ch.carHireSelectedOptions = arrayUtil.filter(ch.carHireSelectedOptions, function(op) {
                                    return op.carHireId === val;
                                });
                                quote.Details = d.Details;
                                quote.showDetailsError = false;
                                quote.viewDetails = true;
                                quote.busy = false;

                                if (deferred) {
                                    deferred.resolve();
                                }

                                if (optionOperation) {
                                    optionOperation.then(updateBasketAndCarHireOptions);
                                }
                                selectingCar = $q.when();
                            }, function() {

                                ch.carHire = angular.copy(ch.noneCarHire);
                                quote.busy = false;

                                quote.showDetailsError = true;
                            });
                        });
                    };

                    selectingCar = selectingCar.then(select);
                    return selectingCar;
                }
                ch.carHire = ch.noneCarHire;
            } else {
                selectingCar = selectingCar.then(function () {
                    return basketStore.removeCar(basketId).then(function () {
                        ch.carHireSelectedOptions = [];
                        if (deferred) {
                            deferred.resolve();
                        }
                        updateBasketAndCarHireOptions();

                    });
                });
                return selectingCar;
            }
        }

        optionOperation = $q.when();

        function optionsWatch(selectedOptions, old) {

            if (!selectedOptions ||
                selectedOptions === old ||
                selectedOptions.length === 0 && !!old && old.length > 1) {
                return;
            }

            optionOperation = optionOperation.then(function () {
                return selectOptions();
            });

            function selectOptions() {
                if (selectedOptions.length >= 1) {

                    if (ch.carHire !== selectedOptions[selectedOptions.length - 1].carHireId) {
                        ch.carHire = selectedOptions[selectedOptions.length - 1].carHireId;

                        deferred = $q.defer();
                        selectedOptions = [selectedOptions[selectedOptions.length - 1]];
                    }
                }
                ch.carHireSelectedOptions = selectedOptions;

                return deferred.promise.then(function () {
                    return addOrRemoveOption(selectedOptions);
                });
            }
        }

        function addOrRemoveOption(selectedOptions) {
            if (ch.carHire === ch.noneCarHire) {
                return $q.when();
            }
            return basketStore.carHireOptions(basketId).then(function (basketOptions) {
                var boNormal = _normaliseCarHireOptions(basketOptions);
                return _missingFrom(boNormal, selectedOptions, updateCarHireOptionsInBasket(basketStore.removeOptions))
                    .then(function () {
                        return _missingFrom(
                            selectedOptions,
                            boNormal,
                            updateCarHireOptionsInBasket(basketStore.addOptions)
                        )
                        .then(function () {
                            return updateBasketAndCarHireOptions();
                        });
                });
            });
        }

        function updateCarHireOptionsInBasket(storeFn) {
            return function (options) {
                var quote = arrayUtil.first(ch.carHireQuotes, function (q) {
                    return angular.equals(q.CarHireId.CarHireCode, ch.carHire);
                });
                if (!quote || !quote.Details) {
                    return $q.when();
                }
                return storeFn.call(
                    basketStore,
                    basketStore.productType.CarHire,
                    quote.Details.DetailsSearchId,
                    options,
                    basketId
                );

            };
        }

        function updateBasketAndCarHireOptions() {
            basketService.updateBasket();
            return basketStore.carHireOptions(basketId);
        }

    }, basketService.bookingAlreadyDone(`carHire: '${$routeParams.tripId}'`));

    function _missingFrom(src, dst, forall) {
        return forall(arrayUtil.map(arrayUtil.filter(src, function (o1) {
            return !arrayUtil.any(dst, function (o2) {
                return angular.equals(o1, o2);
            });
        }), function (optionId) {
            return { OptionId: optionId.optionId, ChosenQuantity: 1 };
        }));
    }
    ch.filterQuotes = extraProductsService.filterQuotes;


    function _normaliseCarHireOptions(bo) {
        var res:any = [];
        angular.forEach(bo, function (b) {
            res.push({ carHireId: ch.carHire, optionId: b });
        });
        return res;
    }

    function _updateSubtitle() {
        if (ch.carHireQuotes && ch.carHire) {
            var carHireQuote = arrayUtil.first(ch.carHireQuotes, function (c) {
                return angular.equals(c.CarHireId.CarHireCode, ch.carHire);
            });
            ch.carHireQuoteDescription = carHireQuote ?
            carHireQuote.Description + ' (' + $filter('customCurrency')(carHireQuote.Price) + ')'
                : null;

        }
    }

}
